window.servicesVersionBugFixesEndCellStyle = function(value, row) {
    if (!value) {
        return false;
    }
    return {
        css: {
            "background-color": row.bug_fixes_end_color
        }
    };
};
